var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.fullPage)?_c('span',{staticClass:"center-child-items"},[_c('div',{staticClass:"loader",class:{ small: _vm.small },style:({
      ..._setup.color,
    })}),(!_vm.hideText)?_c('span',{domProps:{"textContent":_vm._s(_vm.text)}}):_vm._e()]):_c('div',{staticClass:"center-child-items flex-column container"},[_c('v-sheet',{staticClass:"center-child-items",attrs:{"color":"white","height":"80","width":"80"}},[_c('div',{staticClass:"loader",class:{ small: _vm.small },style:({
        ..._setup.color,
      })})]),(!_vm.hideText)?_c('span',{staticClass:"mt-4 font-size-16",domProps:{"textContent":_vm._s(_vm.text)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }